import { Seo } from "@/components/web/Seo";
import { FadeUp } from "@/components/web/Reveal";

const SECTIONS = [
  {
    title: "1. Acceptance of terms",
    body: "By accessing or using the LinkExpln website at linkexpln.com (the \"Service\"), you agree to these Terms of Service. If you do not agree, please do not use the Service.",
  },
  {
    title: "2. Description of the Service",
    body: "LinkExpln provides tools to help users evaluate the safety of URLs, including an AI-assisted URL scanner and a public link-reporting facility. Some features may be marked as pending or in rollout and are provided as-is during that period.",
  },
  {
    title: "3. No guarantee of detection",
    body: "Link analysis is probabilistic. While we work hard to detect phishing, scams and malware, no security tool can guarantee that every dangerous link is identified or that every flagged link is malicious. Verdicts are informational and do not replace your own judgment.",
  },
  {
    title: "4. Acceptable use",
    body: "You agree not to misuse the Service — including attempting to disrupt or overload it, probing or attacking our infrastructure, submitting content designed to harm the Service or other users, or using the Service to facilitate illegal activity.",
  },
  {
    title: "5. Reports you submit",
    body: "When you report a link, you confirm the information you provide is accurate to the best of your knowledge. You grant us the right to use the reported URL and accompanying details to investigate threats and protect users.",
  },
  {
    title: "6. Intellectual property",
    body: "The LinkExpln name, branding, website design and content are the property of LinkExpln and may not be copied or used without permission.",
  },
  {
    title: "7. Disclaimer of warranties",
    body: "The Service is provided \"as is\" and \"as available\" without warranties of any kind, express or implied, including fitness for a particular purpose and non-infringement.",
  },
  {
    title: "8. Limitation of liability",
    body: "To the maximum extent permitted by law, LinkExpln shall not be liable for any indirect, incidental, special or consequential damages arising from your use of, or inability to use, the Service — including losses resulting from interacting with any third-party link.",
  },
  {
    title: "9. Changes to these terms",
    body: "We may update these Terms from time to time. Continued use of the Service after changes take effect constitutes acceptance. The current version is always available at linkexpln.com/terms.",
  },
  {
    title: "10. Contact",
    body: "Questions about these Terms? Reach us via the contact page at linkexpln.com/contact.",
  },
];

export default function Terms() {
  return (
    <>
      <Seo
        title="Terms of Service — LinkExpln"
        description="Terms of Service for LinkExpln — the AI-powered URL scanner and link-safety platform at linkexpln.com."
      />
      <section className="pt-24 pb-16 sm:pt-32 border-b border-white/10">
        <div className="max-w-4xl mx-auto px-5 sm:px-8">
          <p className="ls-overline mb-6">Legal</p>
          <h1 data-testid="terms-heading" className="font-heading font-black tracking-tighter text-white text-4xl sm:text-6xl">
            Terms of Service
          </h1>
          <p className="mt-6 font-mono-ls text-xs tracking-[0.15em] text-zinc-400 uppercase">
            Effective date: June 2026
          </p>
        </div>
      </section>
      <section className="py-20 sm:py-28">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 space-y-14">
          {SECTIONS.map((s) => (
            <FadeUp key={s.title} y={20}>
              <h2 className="font-heading font-bold text-xl text-white mb-4">{s.title}</h2>
              <p className="text-zinc-400 leading-relaxed">{s.body}</p>
            </FadeUp>
          ))}
        </div>
      </section>
    </>
  );
}
